/**
 * Etiquetas en español para estados y métodos de pago de facturas.
 *
 * El backend maneja estos valores en inglés (InvoiceStatus / PaymentStatus /
 * PaymentMethod). Aquí se traducen para que la interfaz se muestre siempre en
 * español, sin "spanglish". También se aceptan los valores ya en español
 * (datos de ejemplo o selects del propio frontend) para no romper nada.
 */

const ESTADO_LABELS = {
  // payment_status (PaymentStatus)
  paid: 'Pagada',
  unpaid: 'Pendiente',
  partial: 'Pago parcial',
  overpaid: 'Sobrepagada',
  // status (InvoiceStatus)
  draft: 'Borrador',
  pending: 'Pendiente',
  sent: 'Enviada',
  partially_paid: 'Pago parcial',
  overdue: 'Vencida',
  cancelled: 'Cancelada',
  voided: 'Anulada',
  // valores ya en español
  pagada: 'Pagada',
  pendiente: 'Pendiente',
  parcial: 'Pago parcial',
  vencida: 'Vencida',
  cancelada: 'Cancelada',
  anulada: 'Anulada',
  borrador: 'Borrador',
  enviada: 'Enviada',
};

const ESTADO_BADGE = {
  paid: 'status-badge--success', pagada: 'status-badge--success', overpaid: 'status-badge--success',
  unpaid: 'status-badge--warning', pending: 'status-badge--warning', pendiente: 'status-badge--warning',
  partial: 'status-badge--info', partially_paid: 'status-badge--info', parcial: 'status-badge--info',
  sent: 'status-badge--info', enviada: 'status-badge--info',
  overdue: 'status-badge--danger', vencida: 'status-badge--danger',
  cancelled: 'status-badge--secondary', cancelada: 'status-badge--secondary',
  voided: 'status-badge--secondary', anulada: 'status-badge--secondary',
  draft: 'status-badge--secondary', borrador: 'status-badge--secondary',
};

const METODO_PAGO_LABELS = {
  // PaymentMethod (backend)
  cash: 'Efectivo',
  bank_transfer: 'Transferencia bancaria',
  credit_card: 'Tarjeta de crédito',
  debit_card: 'Tarjeta de débito',
  check: 'Cheque',
  electronic: 'Pago electrónico',
  other: 'Otro',
  // valores del frontend / términos comerciales
  efectivo: 'Efectivo',
  transferencia: 'Transferencia bancaria',
  tarjeta: 'Tarjeta',
  cheque: 'Cheque',
  credito: 'Crédito',
  terminos: 'Términos',
  cod: 'Contra entrega (COD)',
};

export const estadoFacturaLabel = (estado) =>
  ESTADO_LABELS[String(estado || '').toLowerCase()] || estado || 'Sin estado';

export const estadoFacturaBadgeClass = (estado) =>
  ESTADO_BADGE[String(estado || '').toLowerCase()] || 'status-badge--info';

export const metodoPagoLabel = (metodo) =>
  METODO_PAGO_LABELS[String(metodo || '').toLowerCase()] || metodo || 'No especificado';
